import { useQuery } from "react-query";
import { getDuplicateMatches } from "../../../components/duplicate-staging/lib/productData";

export const useDuplicateMatch = (taskContextKey, enabled) => {
    return useQuery({
        queryKey: ["duplicateMatch", taskContextKey],
        initialData: [],
        enabled,
        queryFn: () => getDuplicateMatches(taskContextKey),
    });
};
